import { Component, EventEmitter, Input, Output } from "@angular/core";

import { Shop } from "@hermes/api-model-shop";

import { DEFAULT_SECTIONS_TO_DISPLAY } from "../../constants/shop.constants";
import {
    DirectionLinkMode,
    SectionName,
    ShopInfoEvent,
    StorePageLinkMode,
} from "../../types/shop-info.type";

/**
 * Interface contains distance (in meters) and list of stores
 */
@Component({
    selector: "h-shop-info",
    templateUrl: "./shop-info.component.html",
    styleUrls: ["./shop-info.component.scss"],
    standalone: false,
})
export class ShopInfoComponent {
    @Input()
    public shop!: Shop;

    @Input()
    public hasHeader = true;

    @Input()
    public hasSeparator = true;

    @Input()
    public linkMode: StorePageLinkMode = "none";

    @Input()
    public directionLinkMode: DirectionLinkMode = "none";

    /**
     * Number of meters between the current location and the shop.
     * Displayed under the direction icon if `directionLinkMode` is set to `icon`
     */
    @Input()
    public meters: number = 0;

    /**
     * Direction link to use if `directionLinkMode` is set to `icon` or `text`.
     */
    @Input()
    public directionUrl: string = "";

    /**
     * Sets the store title level
     */
    @Input()
    public headerLevelShopTitle: number = 3;

    @Input()
    public sectionsToDisplay: Set<SectionName> = DEFAULT_SECTIONS_TO_DISPLAY;

    @Output()
    public shopInfoEvents = new EventEmitter<ShopInfoEvent>();
}
